import { includes } from 'lodash';
import React from 'react';

import './StateNotes.scss';

import If from '../../Shared/If/If';

const StateNotes = ({
  userState,
  mandatoryWithholdingStates,
  nonMandatoryWithholdingStates,
}) => (
  <div className="state-note e2e-state-specific-notes">
    <If test={includes(mandatoryWithholdingStates, userState)}>
      <If test={userState === 'AR'}>
        <li>
          You can elect out of the default state withholding by contacting us
          and processing the transaction by phone. Withholding will not occur on
          direct rollovers.
        </li>
        <li>
          If you continue your transaction online we will treat that as an
          election to withhold Arkansas income tax on any type of distribution
          except a rollover.
        </li>
      </If>
      <If test={userState === 'CA'}>
        State withholding is declined automatically should you elect to decline
        the federal withholding.
      </If>
      <If test={userState === 'CT'}>
        Additional state withholdings may apply to conversions when converting a
        Traditional IRA to a Roth IRA. State withholding cannot be declined.
      </If>
      <If test={userState === 'DC'}>
        You can elect out of this withholding by contacting us and requesting
        the transaction by phone or by paper distribution request.
      </If>
      <If test={userState === 'DE'}>
        State withholding amount could change based on wage table rates. State
        withholding is declined automatically should you elect to decline the
        federal withholding.
      </If>
      <If test={userState === 'IA'}>
        State withholding is declined automatically should you elect to decline
        the federal withholding.
      </If>
      <If test={userState === 'KS'}>
        State withholding calculations are rounded to the nearest dollar based
        on entered redemption amount. State withholding is declined
        automatically should you elect to decline the federal withholding.
      </If>
      <If test={userState === 'ME'}>
        State withholding calculations are rounded to the nearest dollar based
        on entered redemption amount. State withholding is declined
        automatically should you elect to decline the federal withholding.
      </If>
      <If test={userState === 'MA'}>
        State withholding rates may change based on client specific exemptions.
        State withholding calculations are rounded to the nearest dollar based
        on entered redemption amount. State withholding is declined
        automatically should you elect to decline the federal withholding.
      </If>
      <If test={userState === 'MI'}>
        Additional state withholdings may apply to conversions when converting a
        Traditional IRA to a Roth IRA. State withholding cannot be declined.
      </If>
      <If test={userState === 'NC'}>
        State withholding calculations are rounded to the nearest dollar based
        on entered redemption amount. State withholding is declined
        automatically should you elect to decline the federal withholding.
      </If>
      <If test={userState === 'OK'}>
        State withholding calculations are rounded to the nearest dollar based
        on entered redemption amount. State withholding is declined
        automatically should you elect to decline the federal withholding.
      </If>
      <If test={userState === 'OR'}>
        A minimum redemption of $10.00 is required before withholding state
        taxes. State withholding is declined automatically should you elect to
        decline the federal withholding.
      </If>
      <If test={userState === 'VT'}>
        State withholding is declined automatically should you elect to decline
        the federal withholding.
      </If>
    </If>
    <If test={includes(nonMandatoryWithholdingStates, userState)}>
      <div>You live in a non-mandatory State</div>
    </If>
  </div>
);

export default StateNotes;
